<div class="external-package">
  <div class="flex items-center">
    <mat-icon svgIcon="book" class="mr-8"></mat-icon>
    <div class="mat-subtitle-2 mb-0 fs-24 fw-600">{{'INSTANCE_DETAILS.CUSTOM_PACKAGE'| transloco}}</div>
  </div>
  <mat-divider class="neutral-2 mt-12 mb-12 ml-4 mr-4"></mat-divider>
  @if ( externalPackages?.references?.length) {
  <h3 class="mt-0 fs-18">{{externalPackages?.name ? externalPackages?.name: ''}}</h3> }
  @if ( externalPackages?.references?.length) {
  <div class="flex flex-col update-build">
    <div class="flex flex-col border-radius">
      <table mat-table [dataSource]="dataSourceExternalPackages" matSort (matSortChange)="sortData($event)"
        multiTemplateDataRows class="mat-elevation-z8">
        <ng-container matColumnDef="menu">
          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 expand-column"></th>
          <td mat-cell *matCellDef="let data" class="arrow" [ngClass]="{'selected': data.arrowClick}">
            <button
              class="flex justify-center items-center context-menu-icon pl-6 pr-6 pt-8 cursor-pointer expand-column">
              <mat-icon [svgIcon]="!data.arrowClick ? 'chevron_right' : 'expand_more'" class="relative-class"
                (click)="onExternalPackageArrowClick(data)"></mat-icon>
            </button>
          </td>
        </ng-container>
        <ng-container matColumnDef="component">
          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.UPDATE_BUILD.COMPONENT' |
            transloco | uppercase }} </th>
          <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-16 component"
            [ngClass]="{'selected': data.arrowClick}">
            {{data.component | titlecase}} </td>
        </ng-container>
        <ng-container hidden matColumnDef="arrow">
          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"></th>
          <td mat-cell *matCellDef="let data" [ngClass]="{'selected': data.arrowClick}"
            class="route-id cell-data fw-400 fs-16"></td>
        </ng-container>
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" [attr.colspan]="tableColumns.length"
            [ngClass]="{'inner-table': element === expandedPackageElement}" class="inner-table">
            @if (element === expandedPackageElement) {
            <div class="example-element-detail flex-col"
              [@detailExpand]="element === expandedPackageElement ? 'expanded' : 'collapsed'">
              @if (dataSourceInnerImages?.length > 0 || dataSourceInnerPackages?.length > 0) {
              <ng-container>
                <div class="flex flex-row justify-between">
                  @if (dataSourceInnerImages?.length > 0){
                  <div class="package-table-title">
                    <div class="fs-16 mb-12 fw-600">{{'INSTANCE_DETAILS.UPDATE_BUILD.IMAGES' | transloco}}</div>
                    <table mat-table [dataSource]="dataSourceInnerImages" multiTemplateDataRows
                      class="mat-elevation logs">
                      <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef class="fs-12 fw-700 name">
                          {{'INSTANCE_DETAILS.UPDATE_BUILD.NAME' | transloco | uppercase }} </th>
                        <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-14 name" [ngClass]="{'max-w-[200px]': data?.name?.length > 25}"
                          [matTooltip]="data?.name?.length > 25 ? data?.name  : ''" [matTooltipClass]="'tooltip-inner above custom-db'" matTooltipPosition="above">
                          {{ data?.name?.length > 25 ? (data?.name | slice:0:25) + '…' : data?.name }}</td>
                      </ng-container>
                      <ng-container matColumnDef="path">
                        <th mat-header-cell *matHeaderCellDef class="fs-12 fw-700 path">
                          {{'INSTANCE_DETAILS.UPDATE_BUILD.PATH' | transloco | uppercase }} </th>
                        <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-14 path"  [ngClass]="{'max-w-[200px]': data?.path?.length > 25}"
                          [matTooltip]="data?.path?.length > 25 ? data?.path  : ''" [matTooltipClass]="'tooltip-inner above custom-db'" matTooltipPosition="above">
                          {{ data?.path?.length > 25 ? (data?.path | slice:0:25) + '…' : data?.path }}</td>
                      </ng-container>
                      <ng-container matColumnDef="version">
                        <th mat-header-cell *matHeaderCellDef class="fs-12 fw-700 version">
                          {{'INSTANCE_DETAILS.UPDATE_BUILD.VERSION' | transloco | uppercase }} </th>
                        <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-14 version">
                          {{data?.version | titlecase}} </td>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="innerTableColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: innerTableColumns;"></tr>
                    </table>
                  </div>
                  } @else {
                  <div class="package-table-title">
                    <div class="fs-16 mb-12 fw-600">{{'INSTANCE_DETAILS.UPDATE_BUILD.IMAGES' | transloco}}</div>
                    <table [dataSource]="dataSourceInnerLog" mat-table class="mat-elevation logs">
                      <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700">
                          {{'INSTANCE_DETAILS.UPDATE_BUILD.NAME' | transloco | uppercase }} </th>
                      </ng-container>
                      <ng-container matColumnDef="path">
                        <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700">
                          {{'INSTANCE_DETAILS.UPDATE_BUILD.PATH' | transloco | uppercase }} </th>
                      </ng-container>
                      <ng-container matColumnDef="version">
                        <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700">
                          {{'INSTANCE_DETAILS.UPDATE_BUILD.VERSION' | transloco | uppercase }} </th>
                      </ng-container>
                      <ng-container hidden matColumnDef="arrow">
                        <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"></th>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="innerTableColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: innerTableColumns;"></tr>
                    </table>
                    <div class="no-data flex flex-col justify-center pt-8 pb-8 mt-150">
                      <img src="/assets/images/no-data.png">
                      <div class="ml-10">{{'INSTANCE_LIST.NO_DATA_FOUND' | transloco }}</div>
                    </div>
                  </div>
                  }
                  @if( dataSourceInnerPackages?.length > 0){
                  <div class="package-table-title">
                    <div class="fs-16 mb-12 fw-600">{{'INSTANCE_DETAILS.UPDATE_BUILD.PACKAGES' | transloco}}</div>
                    <table mat-table [dataSource]="dataSourceInnerPackages" multiTemplateDataRows
                      class="mat-elevation logs">
                      <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef class="fs-12 fw-700 name">
                          {{'INSTANCE_DETAILS.UPDATE_BUILD.NAME' | transloco | uppercase }} </th>
                        <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-14 name" 
                          [matTooltip]="data?.name?.length > 25 ? data?.name  : ''" [matTooltipClass]="'tooltip-inner above custom-db'" matTooltipPosition="above">
                          {{ data?.name?.length > 25 ? (data?.name | slice:0:25) + '…' : data?.name }}</td>
                      </ng-container>
                      <ng-container matColumnDef="path">
                        <th mat-header-cell *matHeaderCellDef class="fs-12 fw-700 path">
                          {{'INSTANCE_DETAILS.UPDATE_BUILD.PATH' | transloco | uppercase }} </th>
                        <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-14 path"
                          [matTooltip]="data?.path?.length > 25 ? data?.path  : ''" [matTooltipClass]="'tooltip-inner above custom-db'" matTooltipPosition="above">
                          {{ data?.path?.length > 25 ? (data?.path | slice:0:25) + '…' : data?.path }}</td>
                      </ng-container>
                      <ng-container matColumnDef="version">
                        <th mat-header-cell *matHeaderCellDef class="fs-12 fw-700 version">
                          {{'INSTANCE_DETAILS.UPDATE_BUILD.VERSION' | transloco | uppercase }} </th>
                        <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-14 version">
                          {{data?.version | titlecase}} </td>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="innerTableColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: innerTableColumns;"></tr>
                    </table>
                  </div>
                  } @else {
                  <div class="package-table-title">
                    <div class="fs-16 mb-12 fw-600">{{'INSTANCE_DETAILS.UPDATE_BUILD.PACKAGES' | transloco}}</div>
                    <table [dataSource]="dataSourceInnerLog" mat-table class="mat-elevation logs">
                      <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700">
                          {{'INSTANCE_DETAILS.UPDATE_BUILD.NAME' | transloco | uppercase }} </th>
                      </ng-container>
                      <ng-container matColumnDef="path">
                        <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700">
                          {{'INSTANCE_DETAILS.UPDATE_BUILD.PATH' | transloco | uppercase }} </th>
                      </ng-container>
                      <ng-container matColumnDef="version">
                        <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700">
                          {{'INSTANCE_DETAILS.UPDATE_BUILD.VERSION' | transloco | uppercase }} </th>
                      </ng-container>
                      <ng-container hidden matColumnDef="arrow">
                        <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"></th>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="innerTableColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: innerTableColumns;"></tr>
                    </table>
                    <div class="no-data flex flex-col items-center justify-center pt-8 pb-8 mt-150">
                      <img src="/assets/images/no-data.png">
                      <div class="ml-10">{{'INSTANCE_LIST.NO_DATA_FOUND' | transloco }}</div>
                    </div>
                  </div>
                  }
                </div>
              </ng-container>
              }
            </div>
            }
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
        <tr mat-row *matRowDef="let element; columns: tableColumns;" class="example-element-row"
          [class.example-expanded-row]="expandedPackageElement === element">
        </tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
      </table>
    </div>
  </div>
  } @else {
    @if(showSpinner){
      <mat-card class="flex spinner-container spinner">
        <mat-spinner diameter="24" color="primary" mode="indeterminate">
        </mat-spinner>
      </mat-card>
  } @else {
  <div class="no-data flex flex-col items-center justify-center pt-8 pb-8 mt-150">
    <img class="w-106 h-106" src="/assets/images/no-data.png">
    <div class="ml-10 no-data-text">{{'INSTANCE_LIST.NO_DATA_FOUND' | transloco }}</div>
  </div>
  }
}
</div>